import Button from 'components/ui-components/Button';
import { ArchiveIcon } from 'assets/icons';
import { messageModalTypes } from '../groups_listing/approvals_groups_reducer';

const ApprovalsGroupArchived = ({
  groupStatus,
  messaging,
  openModalHandler,
}) => (
  <div role="status" className="group-notification mt-16 ptb-12 pl-18 pr-14 fl">
    <ArchiveIcon width={20} height={18} />
    <div className="ml-10">
      <h3 className="ff-body fw-600 fs-16 tc-grey-70 lh-1 mb-5">
        {messaging.title}
      </h3>
      <p className="ff-body fs-16 tc-grey-70 mb-0">{messaging.body}</p>
    </div>
    <Button
      handleClick={() =>
        openModalHandler(
          groupStatus.status === 'active'
            ? messageModalTypes.ARCHIVE
            : messageModalTypes.UNARCHIVE,
        )
      }
      className="group-notification__btn cef-btn cef-btn--grey ml-auto">
      Unarchive Group
    </Button>
  </div>
);
export default ApprovalsGroupArchived;
